const defaultOptions = {
  async: true
};
export default function (source, callback = null, options = null) {
  const element = document.createElement('script');

  // Merge with default options.
  options = options ? Object.assign({}, defaultOptions, options) : defaultOptions;
  // Assign options.
  if (options.async) {
    element.setAttribute('async', 'true');
    element.async = true;
  }
  if (options.type) {
    element.setAttribute('type', options.type);
  }
  if (options.id) {
    element.setAttribute('id', options.id);
  }
  element.src = source;
  if (callback) {
    element.addEventListener('load', callback, {
      once: true
    });
  }
  document.body.appendChild(element);
}